export const getNetworkIcon = (chainSlug) => {
    switch (chainSlug) {
        case 'polygon':
            return '/assets/chains/polygon.png'
        case 'ethereum':
            return '/assets/chains/ethereum.png'
        case 'binance':
            return '/assets/chains/binance.png'
        case 'avalanche':
            return '/assets/chains/avalanche.png'
        case 'arbitrum':
            return '/assets/chains/arbitrum.png'
        case 'optimism':
            return '/assets/chains/optimism.png'
        case 'fantom':
            return '/assets/chains/fantom.png'
        default:
            return '/assets/chains/polygon.png'
    }
}

export const getNetworkExplorer = (chainSlug) => {
    switch (chainSlug) {
        case 'polygon':
            return 'https://polygonscan.com/'
        case 'ethereum':
            return 'https://etherscan.com/'
        case 'binance':
            return 'https://bscscan.com/'
        case 'avalanche':
            return 'https://snowtrace.io/'
        case 'arbitrum':
            return 'https://arbiscan.io/'
        case 'optimism':
            return 'https://optimistic.etherscan.io/'
        case 'fantom':
            return 'https://ftmscan.com/'
        default:
            return 'https://polygonscan.com/'
    }
}

export const getNetworkRpc = (chainSlug) => {
    switch (chainSlug) {
        case 'polygon':
            return 'https://polygon-bor-rpc.publicnode.com'
        case 'ethereum':
            return 'https://ethereum-rpc.publicnode.com'
        case 'binance':
            return 'https://bsc-rpc.publicnode.com'
        case 'avalanche':
            return 'https://avalanche-c-chain-rpc.publicnode.com'
        case 'arbitrum':
            return 'https://arbitrum-one-rpc.publicnode.com'
        case 'optimism':
            return 'https://optimism-rpc.publicnode.com'
        case 'fantom':
            return 'https://fantom-rpc.publicnode.com'
        default:
            return 'https://polygon-bor-rpc.publicnode.com'
    }
}

export const getNetworkPluriAddress = (chainSlug) => {
    switch (chainSlug) {
        case 'polygon':
            return '0xe469e49A15cF9c6B0C2685027eBb8bE43363bE33'
        case 'ethereum':
            return '0x6337c3e9c04A0fC81e8cF689029eFaD88D67Fe2D'
        case 'binance':
            return '0x9D68671a77419E5C22BE70881F8D728b6a2dD1FD'
        case 'avalanche':
            return '0x9702230A8Ea53601f5cD2dc00fDBc13d4dF4A8c7'
        case 'arbitrum':
            return '0x8772dDF9b63fE761b4e316082781517F6832F9ca'
        case 'optimism':
            return '0xe3ba04fA23A8276e0C9B8A668e4b5628bA7c0E96'
        case 'fantom':
            return '0x8772dDF9b63fE761b4e316082781517F6832F9ca'
        default:
            return '0xe469e49A15cF9c6B0C2685027eBb8bE43363bE33'
    }
}


